export const KEY_GET_SURVEYS_CAMPAIGNS = 'get.surveys-campaigns.call';
export const KEY_POST_SURVEYS_CAMPAIGNS = 'post.surveys-campaigns.call';
export const KEY_GET_SURVEY_CAMPAIGN_BY_ID = 'get.survey-campaign-by-id.call';
export const KEY_PUT_SURVEY_CAMPAIGN_BY_ID = 'put.survey-campaign-by-id.call';
export const KEY_POST_SURVEYS_CAMPAIGN_BY_ID_NEXT = 'post.surveys-campaign-by-id-next.call';
export const KEY_POST_SURVEYS_CAMPAIGN_BY_ID_END = 'post.surveys-campaign-by-id-end.call';

export const KEY_GET_TEMPLATES = 'get.templates.call';
export const KEY_GET_TEMPLATE_BY_ID = 'get.template-by-id.call';

export const KEY_GET_SURVEY_CAMPAIGN_INVITATION_BY_TEMPLATE_ID =
  'get.survey-campaign-invitation-by-template-id.call';

export const KEY_POST_SURVEYS_CAMPAIGN_BY_ID_REMINDER = 'post.surveys-campaign-by-id-reminder.call';
export const KEY_GET_SURVEYS_CAMPAIGN_BY_ID_REMINDER_EMPLOYEES =
  'get.surveys-campaign-by-id-reminder-employess.call';

export const KEY_GET_SURVEY_CAMPAIGN_BY_ID_RESPONSES_STATS =
  'get.surveys-campaign-by-id-responses-stats.call';

export const KEY_GET_SURVEY_CAMPAIGN_BY_ID_RESPONSES_RESULTS_STATS =
  'get.surveys-campaign-by-id-responses-results-stats.call';

export const KEY_GET_EMPLOYER_NOT_COMPLETED_SURVEYS = 'get.employer-not-completed-surveys.call';

export const KEY_POST_EMPLOYER_BY_ID_SURVEY_RESULT = 'post.employer-by-id-survey-result.call';

export const KEY_PUT_SURVEY_CAMPAIGN_VISIBILITY = 'put.survey-campaign-visibility.call';

export const KEY_GET_SURVEY_CAMPAIGNS_RESULTS_STATS = 'get.survey-campaigns-results-stats.call';

export const KEY_POST_TEMPLATE_SIMULATE = 'post.template-simulate.call';
